import defaultSwrvConfig from 'app/config/swrvConfig';
import useSWRV from 'swrv';

export default function useConfiguredSWRV(key, fetcher, config = {}) {
    return useSWRV(key, fetcher, { ...defaultSwrvConfig, ...config });
}
